// Some invalidation is done very often, like for example file uploads
// and we want to avoid invalidating 10 times in 1 second.
// This hook provides a way to debounce invalidations for a specific query key.

import { DebouncedFunction, useDebounceFn } from "@nens/react/hooks";

export const useDebounceInvalidation = <T extends DebouncedFunction>(invalidationFunc: T) => {
  return useDebounceFn(invalidationFunc, 1000, { leading: true }).run;
};
